import {HTMLAttributes} from 'react';

export function ChevronBlackIcon(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M-1.72611e-08 0.894888C-1.2316e-08 0.781758 0.0620012 0.669683 0.182087 0.591439C0.396526 0.451993 0.71541 0.474549 0.894007 0.641954L4.99988 4.48845L9.10575 0.641954C9.28437 0.474549 9.60324 0.451994 9.81798 0.591439C10.0324 0.731119 10.0618 0.979577 9.88268 1.14745L5.38849 5.35785C5.29248 5.44807 5.15013 5.5 5.00025 5.5C4.85022 5.5 4.70801 5.44819 4.61201 5.35785L0.117818 1.14745C0.0385122 1.07344 0.000138262 0.983688 0.000138266 0.894759L-1.72611e-08 0.894888Z"
        fill="#4D4D4F"
      />
    </svg>
  );
}
